export const QA_NAME_REQUEST_ARCHIVED_PIPELINES_MODAL =
  'requestArchivedPipelinesModal'

export const QA_NAME_REQUEST_ARCHIVED_PIPELINES_RESTORE_BUTTON =
  'requestArchivedPipelinesRestore'

export const QA_NAME_REQUEST_ARCHIVED_PIPELINES_MORE_BUTTON =
  'requestArchivedPipelinesMore'

export const REQUEST_ARCHIVED_PIPELINES_MODAL_TABLE_CELL_NAME = {
  archived: 'updated',
  category: 'category',
  created: 'created',
  title: 'title',
}

export const REQUEST_ARCHIVED_PIPELINES_MODAL_PAGINATION = {
  page: 1,
}
